module.exports = __webpack_public_path__ + "src/_content/imgs/spinner.svg?6d0128fb73e1f8f5d8d88bfc4c31053e";